var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.hasReadRights)?_c('div',{staticClass:"card-body"},[(_vm.loading)?_c('div',{staticClass:"loader"}):_c('div',{staticClass:"m-3",domProps:{"innerHTML":_vm._s(_vm.infoData)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }